
export const EDITOR_ACTIONS = [
  {
    custom: true,
    icon: 'search-icon',
    action: 'search',
    tooltip: 'search',
    color: 'primary',
    aria: 'search',
  },
  {
    custom: true,
    icon: 'redo',
    action: 'undo',
    tooltip: 'undo',
    color: 'primary',
    aria: 'undo',
    testId: 'undo'
  },
  {
    custom: true,
    icon: 'undo',
    action: 'redo',
    tooltip: 'redo',
    color: 'primary',
    aria: 'redo',
    testId: 'redo'
  },
]
